// extracted by mini-css-extract-plugin
export default {"counter":"QuillEditor_counter__VAiUt"};